import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IMG_DEFAULT, noDataImg, MyIcon } from '../../common/baseConfig';
import { Link } from "react-router-dom";
import { Button } from 'antd';
import NoneData from "../common/NoneData";
import * as actions from './redux/actions';

export class Home extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    //获取我的课程数据
    this.props.actions.fetchGetMyCourse({
      PageSize: 1,
      PageIndex: 1,
      PageStatus: 1,
    });
    //获取我的题库数据
    this.props.actions.fetchGetMyQuestion({
      PageSize: 1,
      PageIndex: 1,
      PageStatus: 1,
    });
    //获取通知公告
    // this.props.actions.fetchMessageData({
    //   SortType: 0,
    // });
    this.props.actions.fetchStudentPublicList();
    //获取我的订单数据
    this.props.actions.fetchGetWaitPay({
      PageSize: 99,
      PageIndex: 1,
      PageStatus: 1,
      PayStatus: 0,
    })
  }
  analyOrderData(orderData) {
    let data = [...orderData.OrderDetailList, ...orderData.OrderDetailListPack, ...orderData.OrderDetailListStage];

    return data[0];
  }
  render() {
    let {
      fetchGetMyCourseSuccess,
      fetchGetMyQuestionSuccess,
      fetchGetWaitPaySuccess,
    } = this.props.center;
    let { messageData } = this.props.home;
    messageData = messageData.slice(0, 3);
    let scale = 0;
    if (fetchGetMyQuestionSuccess && fetchGetMyQuestionSuccess.length > 0) {
      scale =
        fetchGetMyQuestionSuccess && fetchGetMyQuestionSuccess[0].RightCounts === 0
          ? 0
          : (
            fetchGetMyQuestionSuccess[0].RightCounts / fetchGetMyQuestionSuccess[0].TotalCounts
          ).toFixed(2) * 100;
    }
    return (
      <div className="center-home">
        <div className="left">
          <div className="my-course">
            <h1>我的课程</h1>
            {fetchGetMyCourseSuccess && fetchGetMyCourseSuccess.length > 0 ? (
              <div className="my-course-content">
                <div className="my-course-content-left">
                  <img src={fetchGetMyCourseSuccess[0].CoverPath ? fetchGetMyCourseSuccess[0].CoverPath + '?x-oss-process=image/resize,m_fixed,h_90,w_160' : IMG_DEFAULT} alt="" />
                  <h2>
                    <p>
                      {fetchGetMyCourseSuccess[0].Name}-
                      {fetchGetMyCourseSuccess[0].Teacher || '匿名'}
                    </p>
                    <p>
                      已学
                      {fetchGetMyCourseSuccess[0].LookHours >= fetchGetMyCourseSuccess[0].SumHours ? "100" : ((fetchGetMyCourseSuccess[0].LookHours / fetchGetMyCourseSuccess[0].SumHours) * 100).toFixed(2)}%
                    </p>
                  </h2>
                </div>
                <div className="my-course-content-right">
                  <Button
                    type="theme"
                    className="my-course-btn"
                    onClick={() => {
                      //跳到上次播放学习页面
                      this.props.history.push(`/course/video/${fetchGetMyCourseSuccess[0].ID}-${fetchGetMyCourseSuccess[0].ChapterId}-${fetchGetMyCourseSuccess[0].WareId}`);
                    }}
                  >
                    继续上次学习
                  </Button>
                  <Button
                    type="theme2"
                    className="my-course-btn"
                    onClick={() => {
                      this.props.history.push(`/course/detail/${fetchGetMyCourseSuccess[0].ID}`);
                    }}
                  >
                    进入我的课程
                  </Button>
                </div>
              </div>
            ) : (
                <div className="nodata">
                  <img src={noDataImg} alt="" />
                  <p>暂无学习记录，快去寻找<Link to="/courseList">感兴趣的课程>></Link></p>
                </div>
              )}
          </div>
          <div className="my-question">
            <h1>我的题库</h1>
            {fetchGetMyQuestionSuccess && fetchGetMyQuestionSuccess.length > 0 ? (
              <div className="my-question-content">
                <div className="my-question-content-left">
                  <h2>
                    {fetchGetMyQuestionSuccess[0].Title}>
                    {fetchGetMyQuestionSuccess[0].BusType === 0
                      ? fetchGetMyQuestionSuccess[0].ExamPaperType
                        ? '历年真题'
                        : '模拟考试'
                      : '章节练习'}
                  </h2>
                  <h3>{fetchGetMyQuestionSuccess[0].QuestionStoreName}</h3>
                  <h4>
                    <p>
                      <span style={{ width: `${scale}%` }} />
                    </p>
                    <p>已完成 {scale}%</p>
                  </h4>
                </div>
                <div className="my-question-content-right">
                  <Button type="theme" className="my-question-btn" onClick={() => {
                    if (fetchGetMyQuestionSuccess[0].ExamPaperType) {
                      //章节
                      this.props.history.push(`/exer/exam/detail/${fetchGetMyQuestionSuccess[0].BusID}`);
                    } else {
                      //考试
                      this.props.history.push(`/exer/chapter/exam/continue/${fetchGetMyQuestionSuccess[0].BusID}`);
                    }
                  }}>
                    进入继续做题
                  </Button>
                </div>
              </div>
            ) : (
                <div className="noneData">
                  <NoneData type={3} />
                </div>
              )}
          </div>
        </div>
        <div className="right">
          <div className="notification">
            <h1>通知公告</h1>
            {messageData.length > 0 ? (
              <ul className="notification-content">
                {messageData.map(item => (
                  <li key={item.MessageId} onClick={() => {
                    this.props.history.push(`/center/message/0?MessageID=${item.MessageId}`);
                  }}>
                    <MyIcon type="iconxiaoxi" className="notification-icon" />
                    {item.IsTopping ? "【置顶】" : ""}{item.Title}
                  </li>
                ))}
              </ul>
            ) : (
                <div className="nodata">
                  <p>暂无通知公告</p>
                </div>
              )}
          </div>
          <div className="my-order">
            <h1>我的订单</h1>
            <div className="my-order-wait">
              <Link to="/center/myOrder/1" className="my-order-wait-left" name={fetchGetWaitPaySuccess && fetchGetWaitPaySuccess.length}>
                <img src={require("../../images/order.png")} alt="" />
                <p>待付款课程</p>
              </Link>
              <Link to="/center/myOrder/0" className="my-order-wait-right">
                <p><MyIcon type="iconxiala2" /></p>
                <p>全部订单</p>
              </Link>
            </div>
            {
              fetchGetWaitPaySuccess && fetchGetWaitPaySuccess.length > 0 ? <div className="my-order-data">
                <div className="my-order-wait-data">
                  <img src={this.analyOrderData(fetchGetWaitPaySuccess[0]).CoverPath || IMG_DEFAULT} alt="" />
                  <h5>
                    <p>您提交了订单,等待付款</p>
                    <p>¥{this.analyOrderData(fetchGetWaitPaySuccess[0]).PreferentialPrice.toFixed(2)}</p>
                  </h5>
                </div>
                <Button type="theme2" className="dataBtn" onClick={() => {
                  this.props.history.push(`/paytype/${fetchGetWaitPaySuccess[0].OrderId}`)
                }}>查看详情</Button>
              </div> : <div className="my-order-nodata">
                  <p>这里都空空的，去挑选一些合适的课程吧！</p>
                  <Button type="theme2" className="nodataBtn" onClick={() => {
                    this.props.history.push('/courseList');
                  }}>去逛逛</Button>
                </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
    home: state.home
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);



// WEBPACK FOOTER //
// ./src/features/center/Home.js